import { FC } from 'react';

import * as Styles from './bullet-quantity.styles';

type BulletQuantityProps = {
  quantity: number;
}

const BulletQuantity: FC<BulletQuantityProps> = ({ quantity }) => {
  return (
    <Styles.Bullet>
      {quantity}
    </Styles.Bullet>
  );
};

export default BulletQuantity;
